import {Category} from './category';

export class CategoryDto {
  category: Category;
}
